<ion-app *resolution="'mobile'">
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>

<router-outlet *resolution="'desktop'" id="main"></router-outlet>
